import { render, staticRenderFns } from "./ProRenewalAlert.vue?vue&type=template&id=e8d00e82&scoped=true&"
import script from "./ProRenewalAlert.vue?vue&type=script&lang=js&"
export * from "./ProRenewalAlert.vue?vue&type=script&lang=js&"
import style0 from "./ProRenewalAlert.vue?vue&type=style&index=0&id=e8d00e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d00e82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VIcon,VTooltip})
